module.exports = __webpack_public_path__ + "img/air.85974b12.svg";